<template>
    <section>
        <slot v-if="$slots.title" name="title" />
        <row class="mt-4">
            <column v-if="hasFeature('asset-status-check')">
                <cadence-config-form
                    v-model="form.statusCheckCadence"
                    :errors="form.errors.statusCheckCadence"
                    :title="trans('assetstatuschecks.configuration.form.cadence.title')"
                />
            </column>
        </row>
        <row>
            <column>
                <cadence-config-form
                    v-model="form.testCadence"
                    :errors="form.errors.testCadence"
                    :title="trans('tests.configuration.form.cadence.title')"
                />
            </column>
        </row>
        <row>
            <column>
                <cadence-config-form
                    v-model="form.maintenanceCadence"
                    :errors="form.errors.maintenanceCadence"
                    :title="trans('maintenances.configuration.form.cadence.title')"
                />
            </column>
        </row>
    </section>
</template>
<script setup>
import CadenceConfigForm from '@/Components/CadenceConfigForm.vue';
import { hasFeature } from '@/mixins/hasFeature.js';

defineProps({ form: Object });
</script>
